module.exports = __webpack_public_path__ + "img/179.20a71c58.jpg";